const CONFIG = {
    API_URL: "https://icffapi.worldgurujiedu.org",
};

export default CONFIG;
